import { useNavigate } from "react-router";
import React, { useState, useEffect } from "react";
import DgButton from "../DgButton";
import Swal from "sweetalert2";
import { getFromSession } from "../../utils/sessionUtils";

function Sidebar({ data, role }) {
  const navigate = useNavigate();
  const [active, setActive] = useState("/");
  const devAlert = () => {
    Swal.fire({
      title: "Under Development",
      text: "Work in progress",
      icon: "warning",
    });
  };

  useEffect(() => {
    setActive(window.location.pathname);
  }, []);

  return (
    <>
      <div className="sidebar">
        <div className="modules">
          {data.map((module) => (
            <div
              key={module.path}
              onClick={() => navigate(module.path)}
              className={
                "module " +
                (module.path == active ? "active" : "") +
                (module.value == "settings" ? "settings" : "")
              }
            >
              <div className="item">
                <img
                  src={
                    "/assets/icons/sidebar/" +
                    module.icon +
                    (module.path == active ? "-active" : "") +
                    ".svg"
                  }
                  alt=""
                  className="icon"
                />
                <span>{module.title}</span>
              </div>
            </div>
          ))}
        </div>
        {role === "customer" && (
          <div className="advisor-help">
            <div className="cont">
              <img
                src="/assets/illos/advisor-help.png"
                alt=""
                className="help-img"
              />
              <p className="description">
                Get in contact with a professional financial advisor to modify
                your investments profit
              </p>
              <DgButton
                category="secondary"
                size="small"
                action={() => {
                  const advisorPhone = getFromSession("advisorPhone");
                  if (advisorPhone) {
                    window.open(`https://wa.me/${advisorPhone}`, "_blank");
                  } else {
                    Swal.fire(
                      "Oops",
                      "It seems that this advisor hasn't completed his/her contact info, please reach out support.",
                      "warning"
                    );
                  }
                }}
                text="Contact Advisor"
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Sidebar;
